import React from 'react'

import PropTypes from 'prop-types'

import DesignersList from 'Pods/Shared/DesignersList/DesignersList'
import Sticky from 'Pods/Shared/Sticky'
import Tabs from 'Pods/Shared/Tabs/Tabs'
import withRouter from 'Pods/Shared/withRouter'

import { LessThanBreakpoint } from 'Utils/GetBreakpoint'

import JobApplicants from './Components/JobApplicants'
import JobDescription from './Components/JobDescription'
import JobMessaging from './Components/JobMessaging'
import JobPageContent from './Components/JobPageContent'

class JobPage extends React.Component {
  constructor() {
    super()

    this.state = {
      data: {},
      meta: {},
      included: [],
      isDataFetched: false,
      priceOffer: null,
      activeTabId: '',
      applicantActions: {
        primary: [],
        secondary: [],
      },
      initialHeight: 0,
      topOffset: 0,
      isResponsive: false,
    }

    this.navBarRef = React.createRef()

    this.onFetchSuccess = this.onFetchSuccess.bind(this)
    this.updateOffer = this.updateOffer.bind(this)
    this.fetchData = this.fetchData.bind(this)
    this.inviteDesigners = this.inviteDesigners.bind(this)
    this.checkViewport = this.checkViewport.bind(this)
  }

  componentDidMount() {
    this.checkViewport()
    this.fetchData()

    window.addEventListener('resize', this.checkViewport);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkViewport);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.activeTabId != '' && prevState.activeTabId === this.state.activeTabId) {
      this.setState({ activeTabId: '' })
    }

    if (this.state.isDataFetched && prevState.initialHeight === 0 && prevState.topOffset === 0) {
      const navBar = this.navBarRef.current.getBoundingClientRect()

      this.setState({
        initialHeight: navBar.height,
        topOffset: document.getElementById('navigation-header').clientHeight,
      })
    }
  }

  checkViewport() {
    this.setState({ isResponsive: LessThanBreakpoint('md') })
  }

  fetchData(refetch = false) {
    axios.get(`/api/internal/jobs/${this.props.match.params.id}`)
      .then((response) => this.onFetchSuccess(response, refetch))
      .catch((error) => {})
  }

  onFetchSuccess(response, refetch) {
    if (refetch) {
      const currentState = this.state

      currentState.data.attributes.updatesCount = response.data.data.attributes.updatesCount

      this.setState(currentState)
    } else {
      this.setState({
        data: response.data.data,
        meta: response.data.meta,
        included: response.data.included,
        isDataFetched: true,
      })
    }

    this.props.updateTitle(`${response.data.data.attributes.title.substr(0, 30)}...`)
    this.closeAlerts()
  }

  updateOffer(offer, actions, id) {
    const currentState = this.state

    this.fetchData(true)

    currentState.priceOffer = offer
    currentState.applicantActions = actions
    currentState.data.attributes.applicationId = id

    this.setState(currentState)
  }

  closeAlerts() {
    axios.put(`/api/internal/jobs/${this.props.match.params.id}/close_alerts`)
      .catch((error) => {})
  }

  resolveFirstTab() {
    const isPublicOrPrivate = ['public', 'private'].includes(this.state.data.attributes.type)

    if (this.state.data.attributes.isViewerDesigner) {
      if (isPublicOrPrivate && this.state.data.attributes.status === 'approved') {
        return { title: 'My offer' }
      }
      return { title: 'Messaging' }
    }
    if (this.state.data.attributes.status !== 'started'
          && this.state.data.attributes.status !== 'finished'
          && this.state.isDataFetched) {
      const jobActions = {
        offerValue: this.state.priceOffer > 0 ? this.state.priceOffer : this.state.data.attributes.price,
        isViewerDesigner: this.state.data.attributes.isViewerDesigner,
        status: this.state.data.attributes.status,
        type: this.state.data.attributes.type,
        inviteUrl: this.state.data.attributes.inviteUrl,
        slug: this.state.data.attributes.slug,
      }
      return {
        title: 'Applicants',
        contents: <JobApplicants
          id={this.state.data.id}
          isPublicOrPrivate={['public', 'private'].includes(this.state.data.attributes.type)}
          updateOffer={this.updateOffer}
          changeTab={this.inviteDesigners}
          jobActions={jobActions}
        />,
      }
    }
    return { title: 'Messaging' }
  }

  resolveInviteDesignersTab() {
    const isPublicOrPrivate = ['public', 'private'].includes(this.state.data.attributes.type)

    if (!this.state.data.attributes.isViewerDesigner) {
      if (isPublicOrPrivate && this.state.data.attributes.status === 'approved') {
        return {
          id: 'invite-designers',
          title: 'Invite 3D designers',
          contents: <DesignersList
            inviteDesignersPage
            meta={this.props.meta}
            invitedUserIds={this.state.data.attributes.invitedUserIds}
            jobId={parseInt(this.state.data.id)}
            softwareIds={this.state.data.attributes.softwareIds}
            skillIds={this.state.data.attributes.skillIds}
            className="projects-designers-list"
          />,
        }
      }
      return null
    }
    return null
  }

  resolveTabs() {
    const actions = {
      primary: this.state.data.attributes.availableActions.primary.concat(
        this.state.applicantActions.primary.filter(
          (action) => !this.state.data.attributes.availableActions.primary.includes(action)
        )
      ),
      secondary: [],
    }

    const jobActions = {
      offerValue: this.state.priceOffer > 0 ? this.state.priceOffer : this.state.data.attributes.price,
      isViewerDesigner: this.state.data.attributes.isViewerDesigner,
      status: this.state.data.attributes.status,
      type: this.state.data.attributes.type,
      inviteUrl: this.state.data.attributes.inviteUrl,
      slug: this.state.data.attributes.slug,
      id: this.state.data.id,
      availableActions: actions,
      applicationId: this.state.data.attributes.applicationId,
    }

    const tabs = [
      {
        id: 'job-messaging',
        contents: <div className="container-fixed">
          <JobMessaging conversationId={String(this.state.data.attributes.conversationId)} jobActions={jobActions} />
                  </div>,
        counter: this.state.data.attributes.updatesCount,
        ...this.resolveFirstTab(),
      },
      {
        title: 'Project details',
        id: 'job-description',
        contents: <div className="container-fixed">
          <JobDescription id={this.state.data.id} data={this.state.data} changeTab={this.inviteDesigners} included={this.state.included} />
                  </div>,
      },
    ]

    if (this.resolveInviteDesignersTab()) {
      tabs.push(this.resolveInviteDesignersTab())
    }

    return tabs
  }

  inviteDesigners() {
    this.setState({
      activeTabId: 'invite-designers',
    })
  }

  render() {
    if (this.state.isDataFetched) {
      const actions = {
        primary: [],
        secondary: this.state.data.attributes.availableActions.secondary,
      }

      const activeTabId = this.state.activeTabId || this.props.location.search.replace('?tab=', '')

      const jobActions = {
        offerValue: this.state.priceOffer > 0 ? this.state.priceOffer : this.state.data.attributes.price,
        isViewerDesigner: this.state.data.attributes.isViewerDesigner,
        status: this.state.data.attributes.status,
        type: this.state.data.attributes.type,
        inviteUrl: this.state.data.attributes.inviteUrl,
        slug: this.state.data.attributes.slug,
        id: this.state.data.id,
        availableActions: actions,
        applicationId: this.state.data.attributes.applicationId,
        asButtons: true,
        isBordered: true,
      }

      return (
        <div className="job-page">
          <div ref={this.navBarRef}>
            {this.state.isResponsive ? (
              <Sticky
                className="job-page__sticky"
                position="top"
                stickyOffset={-this.state.initialHeight}
                offset={this.state.topOffset}
                selfAdjustingWidth
              >
                <JobPageContent title={this.state.data.attributes.title} jobActions={jobActions} isResponsive={this.state.isResponsive} />
              </Sticky>
            ) : (
              <JobPageContent title={this.state.data.attributes.title} jobActions={jobActions} isResponsive={this.state.isResponsive} />
            )}
          </div>
          <Tabs tabs={this.resolveTabs()} activeTabId={this.state.activeTabId || 'job-messaging'} />
        </div>
      )
    }
    return ''
  }
}

JobPage.propTypes = {
  updateTitle: PropTypes.func.isRequired,
}

export default withRouter(JobPage)
